export enum MyRunsSearchMode {
  ALL = 'all',
  MY = 'my',
}
